<template>
	<widget title="Customer Asset Categories" icon="fa-tag">

		<freemium-locked-alert v-if="$store.company.is_freemium == 1"></freemium-locked-alert>

		<form v-on:submit.prevent="addCategory">

			<div class="d-flex align-items-center">

				<label class="mr-3 mb-0 font-weight-bold">Add Category</label>

				<field class="mr-3" :params="{placeholder:'Category Name'}" v-model="name"></field>

				<button 
					type="submit" 
					class="btn btn-success">
					<i class="fa fa-save"></i>
					Add
				</button>
		
			</div>

		</form>

		<table-list
			:records="categories"
			:fields="categoryFields"
			record-name="Category"
			:hide-record-count="true"
			:has-delete="true"
			:sortable="true"
			delete-endpoint="/CustomerAssetCategory/delete"
			v-on:modelChange="fetchCategories">
		</table-list>

	</widget>
</template>
<script type="text/javascript">

import Widget from "@/components/Widget"
import TableList from "@/components/TableList"
import Field from "@/components/Field"
import FreemiumLockedAlert from "@/components/FreemiumLockedAlert"

export default {
	name: "CustomerAssetCategoriesManagerWidget",
	components: {
		Widget,
		TableList,
		Field,
		FreemiumLockedAlert
	},
	props: [],
	data() {
		return {
			name: "",
			categoryFields: [
				{label: "Category Name",key:"name"}
			],
			categories: []
		}
	},
	methods: {
		addCategory() {
			let vm = this

			let payload = {
				name: this.name,
			}

			this.postData("CustomerAssetCategory/save",payload,true).then(response => {
				if (response.success) {
					vm.name = ""

					vm.fetchCategories()
				}
			})
		},
		fetchCategories() {
			let vm = this

			this.spinner(true)

			this.getJSON("CustomerAssetCategory/get").then(response => {
				vm.categories = response.data
				vm.spinner(false)
			})
		}
	},
	created() {
		this.fetchCategories()
	}
}
</script>

